import { ListItemButtonProps, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';

import useGetPaletteFromWhiteLabel from '../../../../hooks/useGetPaletteFromWhiteLabel';
import palette from '../../../../theme/learnerPalette';
import { styleConfigs } from '../../../resources/styleConfigs';
import ListItemButtonWrapper from '../../../wrappers/ListItemButtonWrapper';
import ListItemIconWrapper from '../../../wrappers/ListItemIconWrapper';

interface IListItemStyleProps extends ListItemButtonProps {
  component?: ReactNode;
  to?: string;
}

export const NavItemStyle = styled(ListItemButtonWrapper)<IListItemStyleProps>(({ theme }: { theme: Theme }) => {
  const wlPalette = useGetPaletteFromWhiteLabel();
  const focusBorderColor = wlPalette?.text?.yaleBlue ?? palette.light.borders.yaleBlue;
  const activeColor = wlPalette?.text?.main ?? palette.light.text.prussianBlue;
  const indicatorColor = wlPalette?.text?.prussianBlue ?? palette.light.text.prussianBlue;
  const selectedBgColor = wlPalette?.background?.sidebarSelected ?? palette.light.background.sidebarSelected;
  const navColor = palette.light.text.mistBlue;

  return {
    ...theme.typography.body2,
    height: styleConfigs.dimensions.height48,
    color: navColor,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(2.5),
    position: 'relative',
    '&:before': {
      content: "''",
      width: styleConfigs.dimensions.width3,
      top: styleConfigs.marginPadding.empty,
      bottom: styleConfigs.marginPadding.empty,
      right: styleConfigs.marginPadding.empty,
      position: 'absolute',
      backgroundColor: indicatorColor,
      borderTopLeftRadius: styleConfigs.borders.border4,
      borderBottomLeftRadius: styleConfigs.borders.border4,
      display: 'none',
    },
    '&.active': {
      color: activeColor,
      backgroundColor: selectedBgColor,
      '& .MuiListItemIcon-root': {
        color: activeColor,
        '& svg path': {
          stroke: activeColor,
        },
      },
      '&:before': {
        display: 'block',
      },
    },
    '&:focus-visible, &.Mui-focusVisible': {
      border: `${styleConfigs.borders.borderLine2px} ${focusBorderColor} !important`,
      backgroundColor: palette.light.background.transparent,
    },
  };
});

export const NavItemIconStyle = styled(ListItemIconWrapper)({
  width: styleConfigs.dimensions.width22,
  height: styleConfigs.dimensions.height22,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
